import {
  buildHeaderText,
  TabDefinition,
} from '@features/executive-report/slides/header-texts';

const tabDefinitions = [
  { label: 'Overview', id: 'overview' },
  { label: 'The Who', id: 'who', options: { x: 5.05, w: 1.14 } },
  { label: 'The What', id: 'what', options: { x: 6.45, w: 1.24 } },
  { label: 'The Where', id: 'where', options: { x: 7.89, w: 1.38 } },
  { label: 'Summary', id: 'summary', options: { x: 9.48, w: 1.18 } },
  {
    label: 'Recommendations',
    id: 'recommendations',
    options: { x: 10.83, w: 2.22 },
  },
] as const satisfies readonly TabDefinition[];

export type TabId = (typeof tabDefinitions)[number]['id'];

export const headerTabs = (activeTab: TabId) =>
  tabDefinitions.map(tab =>
    buildHeaderText(
      tab.label,
      tab.id === activeTab,
      'options' in tab ? tab.options : undefined
    )
  );
